import { post } from '../utils';

export const sendMail = async (recipient, subject, body) => {
    const path = 'funcs/sendMail/';
    const data = new FormData();
    data.append('recipient', recipient);
    data.append('subject', subject);
    data.append('body', body);
    return await post(path, data);
};